<template>
  <div v-if="!!imageAttributesValues[0] && isImageVisible" class="fill-height">
    <v-hover>
      <template #default="{ hover }">
        <div style="position: relative" class="d-flex justify-center image">
          <img :src="imageAttributesValues[0]" style="max-width: 100%" @error="isImageVisible = false" />
          <base-rounded-button v-if="hover" color="rgba(0,0,0,0.4)" icon="mdi-magnify" @click="openImageLightbox" />
        </div>
      </template>
    </v-hover>
    <image-lightbox :items="imageAttributesValues" :visible.sync="isImageFullScreen" />
  </div>
  <div v-else style="background-color: rgba(0, 0, 0, 0.1)" class="d-flex justify-center align-center py-16 fill-height">
    <v-icon color="#fff">mdi-note-remove-outline</v-icon>
  </div>
</template>

<script>
import BaseRoundedButton from '@/components/shared/buttons/BaseRoundedButton';

export default {
  name: 'SidebarGallery',
  components: { BaseRoundedButton, ImageLightbox: () => import('@/components/shared/ImageLightbox') },
  props: {
    fid: {
      type: [Number],
    },
    lid: {
      type: [Number],
    },
    imageAttributesValues: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    isImageVisible: true,
    isImageFullScreen: false,
  }),
  methods: {
    async openImageLightbox() {
      this.isImageFullScreen = true;
    },
  },
  watch: {
    fid: {
      handler() {
        if (!this.isImageVisible) this.isImageVisible = true;
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .image .v-btn {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
